// extracted by mini-css-extract-plugin
export var container = "TextParser-module--container--1xzp9";
export var dark = "TextParser-module--dark--9mql2";
export var containerColor = "TextParser-module--containerColor--ev9Cx";
export var blue = "TextParser-module--blue--3STqE";
export var pink = "TextParser-module--pink--vSM97";
export var yellow = "TextParser-module--yellow--EW20l";
export var red = "TextParser-module--red--1eOYV";
export var green = "TextParser-module--green--2CADq";
export var rectangle = "TextParser-module--rectangle--3EGlZ";